const THETA = ({ ...props }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.79163 1.93955L4.78511 0.946167H15.2148L16.2083 1.93955V19.9528L15.2148 20.9462H4.78511L3.79163 19.9528V1.93955ZM5.77859 2.93294V18.9594H14.2213V2.93294H5.77859Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M13.1601 13.79H11.0003V16.0525H9.05144V13.79H6.89163V11.8413H13.1601V13.79ZM13.1601 8.20671H11.0003V5.9442H9.05144V8.20671H6.89163V10.1554H13.1601V8.20671Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.99996"
        y1="0.946167"
        x2="9.99996"
        y2="20.9462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2BD2CD" />
        <stop offset="1" stop-color="#2AC4DA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="9.99996"
        y1="0.946167"
        x2="9.99996"
        y2="20.9462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2BD2CD" />
        <stop offset="1" stop-color="#2AC4DA" />
      </linearGradient>
    </defs>
  </svg>
);
export default THETA;
